import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#f3f3f3',
        px: 2,
      }}
    >
      <Typography
        variant="h1"
        sx={{
          color: '#607c89',
          fontWeight: 700,
          mb: 2,
          fontSize: { xs: '3rem', sm: '4rem', md: '6rem' },
        }}
      >
        404
      </Typography>
      <Typography
        variant="h4"
        sx={{
          color: '#607c89',
          fontWeight: 600,
          mb: 3,
          textAlign: 'center',
        }}
      >
        Page Not Found
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: '#888',
          textAlign: 'center',
          mb: 4,
          maxWidth: 500,
        }}
      >
        The page you are looking for does not exist or has been moved.
      </Typography>
      <Button
        variant="contained"
        onClick={() => navigate('/')}
        sx={{
          bgcolor: '#00b6b6',
          color: 'white',
          fontWeight: 700,
          px: 4,
          py: 1.5,
          '&:hover': { bgcolor: '#009e9e' },
          textTransform: 'none',
        }}
      >
        Back to Home
      </Button>
    </Box>
  );
} 